import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowUpRight } = FiIcons;

export default function CTASection() {
  return (
    <section className="bg-[#0b1423] py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div initial={{ opacity: 0, y: 22 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="flex flex-col items-center justify-between gap-9 rounded-[2rem] bg-[#3fc0fa] px-7 py-14 text-center sm:px-14 sm:py-20 lg:flex-row lg:px-20 lg:text-left">
          <div>
            <p className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-[#0b1423]/70">One simple plan · $399/month</p>
            <h2 className="max-w-2xl text-4xl font-black leading-tight tracking-tight text-[#0b1423] sm:text-5xl lg:text-6xl">Your local presence is a full-time job. Let us handle it.</h2>
            <p className="mt-4 max-w-xl text-lg text-[#0b1423]/80">Explore everything included in Local Momentum. A one-time implementation fee applies.</p>
          </div>
          <Link to="/pricing" className="inline-flex shrink-0 items-center gap-3 rounded-full bg-[#0b1423] px-8 py-5 font-bold text-white transition-colors hover:bg-[#22344d]">
            Explore the plan <SafeIcon icon={FiArrowUpRight} />
          </Link>
        </motion.div>
      </div>
    </section>
  );
}